import {useEffect, useState, useRef} from 'react';
import eyeClosed from '../../pics/icons/eyeClosed.png'; 
import eyeOpen from '../../pics/icons/eyeOpen.png'; 
import OptionButton from './OptionButton.js';
import isPlayerImg from '../../pics/icons/isPlayerImg.png';
import isPetImg from '../../pics/icons/pet.PNG';
import FlagPole from './FlagWidget/FlagPole.js';
import EffectImg from '../../pics/icons/effectImg.png';
import { effectImgMap, conditionImgMap } from '../../constants.js';
import Effect from './Effect.js';
import EditAvatar from '../Statblock/EditAvatar.js';
import WidgetPopUp from './WidgetPopUp.js';
import TeamWidgetPopup from './FlagWidget/TeamWidgetPopup.js';
import HpEditPopup from './ListItemHp/HpEditPopup.js';
import ConditionBlock from '../Statblock/PopupBlocks/ConditionBlock.js';
import EffectGridPopup from './EffectGridPopup.js';
import EffectGrid from './EffectGrid.js';

const colors = {
    0: "green",
    1: "orange",
    2: "brown",
}

const EffectGrids = ({creature, creatureListItem, effects, setEffects, currentEncounter, effectDuration, setEffectDuration, conditionDuration, setConditionDuration, socket}) => {

    const updateCreatureEffects = (event, effectName, type) => {
        event.stopPropagation(); 
        const alreadyExists = effects.some(e => e.effectName === effectName);
        
        let updatedEffects = []
        let turnAdded = currentEncounter.roundNum + "." + currentEncounter.turnNum
        let addedBy = currentEncounter?.creatures[currentEncounter.turnNum-1]?.name || 'DM'
        let duration = type === 'spell' ? effectDuration : conditionDuration

        let newEffect = { effectName, addedBy, turnAdded, duration }
        
        if(alreadyExists) {
            updatedEffects = effects.filter(e => e.effectName !== effectName)
        } else {
            updatedEffects = [...effects, newEffect]
        }

        setEffects(updatedEffects)
        socket.emit('creatureEffectChange', newEffect, alreadyExists ? "remove" : "add", creature.creatureGuid, "dm");
    };

    return (
        <div className="dmVieweffectsBarContainer" style={{textWrap: "pretty"}}>
            <div className="effectContainerFlag"/>
            <EffectGrid title={"Spell Effects"} imgMap={effectImgMap} type="spell" effects={effects} duration={effectDuration} setDuration={setEffectDuration} updateCreatureEffects={updateCreatureEffects} />
            <hr className="editLineSeperator" style={{marginBottom: 0}}/>
            <EffectGrid title={"Conditions"} imgMap={conditionImgMap} type="condition" effects={effects} duration={conditionDuration} setDuration={setConditionDuration} updateCreatureEffects={updateCreatureEffects} />
            
            <div className="monsterSearchDetailText"><b>NOTE</b>: If Creature is a DnDBeyond Import</div>
            <div className="monsterSearchDetailText">DM selected Conditions will be overwritten during auto updates. </div>
        </div>
  );
}

export default EffectGrids;